import AddKhasara from "../components/configuration/khasara/AddKhasara";

const AddKhasar = () => {
    return (
        <AddKhasara />
    )
}   
export default AddKhasar;
